// API Configuration

// export const API_BASE_URL = 'http://localhost/brainershub/api/institute';
// export const BASE_URL = 'http://localhost/brainershub';

export const API_BASE_URL = 'https://admin.brainershub.in/api/institute';
 export const BASE_URL = 'https://admin.brainershub.in';

// App Configuration
export const APP_NAME = 'Institute Portal';
export const APP_VERSION = '1.0.0';

// Storage Keys
export const STORAGE_KEYS = {
  USER: 'institute_user',
  TOKEN: 'institute_token',
  SESSION: 'institute_session'
};

// Routes
export const ROUTES = {
  LOGIN: '/login',
  REGISTER: '/register',
  DASHBOARD: '/dashboard',
  COURSES: '/courses',
  TEACHERS: '/teachers',
  EXAMS: '/exams',
  STUDENTS: '/students',
  SETTINGS: '/settings'
};

